<template>
  <tabs-page
    title="Account Management"
    :tabs="tabs"
  />
</template>

<script>
  import RegisteredGuestList from './registered-guest/registered-guest-list.vue';
  import AccountTagsList from './account-tags/account-tags-list.vue';

  export default {
    name: 'AccountManagment',

    computed: {
      tabs() {
        return [
          {
            display: 'Registered Guests',
            name: 'registeredGuests',
            component: RegisteredGuestList
          },
          {
            display: 'Account Tags',
            name: 'accountTags',
            component: AccountTagsList
          }
        ];
      }
    }
  };
</script>
